import React from 'react';
import TrolyWordmark from './TrolyWordmark';

/**
 * TrolyLockup — lockup horizontal Onyx Club (isotipo + wordmark).
 *
 * Asset oficial del DS para identificadores compactos (navbar, headers,
 * emails). Para uso display sin acompañar, ver TrolyWordmark.
 *
 * Props:
 *   inverse   boolean   true → diamante mist + wordmark mist (fondo oscuro)
 *                       false → diamante onyx + wordmark onyx (fondo claro)
 *   size      number|string  font-size del wordmark, isotipo escala 1:1
 *   gap       string    separación isotipo↔wordmark (default 10px)
 *   className string
 */
export default function TrolyLockup({
  inverse = false,
  size = '22px',
  gap = '10px',
  className = '',
  ...rest
}) {
  const diamondColor = inverse ? '#F2EFE9' : '#0E1116';
  const tColor = '#45E6C2';
  const svgSize = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      className={`troly-lockup${className ? ' ' + className : ''}`}
      style={{ display: 'inline-flex', alignItems: 'center', gap, lineHeight: 1 }}
      {...rest}
    >
      <svg
        width={svgSize}
        height={svgSize}
        viewBox="0 0 200 200"
        aria-hidden="true"
        style={{ flexShrink: 0, display: 'block' }}
      >
        <polygon points="100,2 198,100 100,198 2,100" fill={diamondColor} />
        <path d="M58 72 H142 V92 H112 V148 H88 V92 H58 Z" fill={tColor} />
        <rect x="84" y="148" width="32" height="6" fill={tColor} />
      </svg>
      <TrolyWordmark inverse={inverse} size={size} />
    </span>
  );
}
